import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./Reviews.scss"

const Reviews = ({ section }) => {
  const [controllers, setControllers] = React.useState([])
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const [currentSlidedBy, setCurrentSlidedBy] = React.useState(0)

  const handleResize = () => {
    if (window.innerWidth <= 600) {
      setControllers([...Array(5)])
    } else if (window.innerWidth <= 800) {
      setControllers([...Array(4)])
    } else {
      setControllers([...Array(3)])
    }
  }
  React.useEffect(() => {
    handleResize()
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const handleSlide = (e, idx) => {
    e.stopPropagation()
    if (idx === currentIndex) return
    const delta = idx - currentIndex
    const slideBy = document.querySelector(
      ".reviews__wrapper__slider__card"
    ).clientWidth
    const sliderElement = document.querySelector(".reviews__wrapper__slider")
    const temp = -(currentSlidedBy + slideBy * delta)
    sliderElement.style.transform = `translateX(${temp}px)`
    setCurrentSlidedBy((prev) => prev + slideBy * delta)
    setCurrentIndex(idx)
  }
  return (
    <section className="reviews">
      <Fade>
        <div className="reviews__header">
          {section.title || "Lorem Ipsum Title"}
        </div>
        <div className="reviews__wrapper">
          <div className="reviews__wrapper__slider">
            <div className="reviews__wrapper__slider__card">
              <p>
                {section.review1 ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <p>- {section.author1 || "Lorem Ipsum"}</p>
            </div>
            <div className="reviews__wrapper__slider__card">
              <p>
                {section.review2 ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <p>- {section.author2 || "Lorem Ipsum"}</p>
            </div>
            <div className="reviews__wrapper__slider__card">
              <p>
                {section.review3 ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <p>- {section.author3 || "Lorem Ipsum"}</p>
            </div>
            <div className="reviews__wrapper__slider__card">
              <p>
                {section.review4 ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <p>- {section.author4 || "Lorem Ipsum"}</p>
            </div>
            <div className="reviews__wrapper__slider__card">
              <p>
                {section.review5 ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <p>- {section.author5 || "Lorem Ipsum"}</p>
            </div>
          </div>
          <div className="reviews__wrapper__controllers">
            {controllers.map((el, index) => (
              <button
                key={index}
                className={`reviews__wrapper__controllers__btn ${
                  index === currentIndex &&
                  "reviews__wrapper__controllers__btn-active"
                }`}
                onClick={(e) => handleSlide(e, index)}
              ></button>
            ))}
          </div>
        </div>
      </Fade>
    </section>
  )
}

Reviews.propTypes = {
  section: PropTypes.object.isRequired,
}

export default Reviews
